import { render, staticRenderFns } from "./CertySignLogo.vue?vue&type=template&id=c20c3c4a&scoped=true"
import script from "./CertySignLogo.vue?vue&type=script&lang=js"
export * from "./CertySignLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20c3c4a",
  null
  
)

export default component.exports